'use strict';

var classNames = require('classnames');
var react = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);
const listItemNamespace = 'andes-list__item';
const MEDIUM = 'medium';
const getListItemClassNames = props => {
  var _leftContent$type;
  const {
    className,
    size = MEDIUM,
    selected,
    paddingSize,
    disabled,
    leftContent,
    description
  } = props;
  const isThumbnail = /*#__PURE__*/react.isValidElement(leftContent) && (leftContent === null || leftContent === void 0 || (_leftContent$type = leftContent.type) === null || _leftContent$type === void 0 ? void 0 : _leftContent$type.displayName) === 'Thumbnail';
  const imageHasSrc = (leftContent === null || leftContent === void 0 ? void 0 : leftContent.src) && typeof leftContent.src === 'string';
  const listItemClassNames = classNames__default["default"](listItemNamespace, className, "".concat(listItemNamespace, "--size-").concat(size), {
    ["".concat(listItemNamespace, "--selected-padding-0")]: selected && paddingSize === '0',
    ["".concat(listItemNamespace, "--padding-").concat(paddingSize)]: paddingSize,
    ["".concat(listItemNamespace, "--disabled")]: disabled,
    ["".concat(listItemNamespace, "--selected")]: selected,
    ["".concat(listItemNamespace, "-with-image")]: imageHasSrc || isThumbnail,
    ["".concat(listItemNamespace, "-with-secondary")]: description && size !== 'small'
  });
  return listItemClassNames;
};
module.exports = getListItemClassNames;
